import React, { useState, useContext } from "react";
import styles from "./AppStreamButton.module.css";

const AppStreamButton = ({ application, width }) => {

  const launchAppStream = (link) => {
    window.open(link)
  };

  return (
    
        <button className={styles.button} onClick={() => launchAppStream(application.link)}>
          <div className={styles.selector}>
            <img
              style={{
                width: width,
              }}
              src={application.image}
              className="request-shadow"
            />
          </div>
          <span>{application.title}</span>
        </button>
      
  );
};

export default AppStreamButton;
